import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { BiImageAdd } from "react-icons/bi";
import { BsImage } from "react-icons/bs";
import useDialogState, { Loader } from "../../hook";
import Parallax4DImageService from "../../services/parallax4D.service";
import { notifyError, notifySuccess } from "../../hook/notification";
import * as yup from "yup";
import CategoryService from "../../services/category.service";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { MdDeleteOutline } from "react-icons/md";
import NotificationService from "../../services/notification.service";
import CollectionService from "../../services/collection.service";

// Custom Dropdown component
const Dropdown = ({ options, onSelect, selectedValue }) => {
  const menuRef = useRef();
  const [toggleShow, setToggleShow] = useState(false);

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="flex flex-col gap-2 relative">
      <div onClick={userToggle} className="input cursor-pointer">
        {selectedValue === "" ? "Select" : selectedValue}
      </div>
      <div
        className={`${
          toggleShow ? "block" : "hidden"
        } bg-gray-800 rounded-6 overflow-hidden absolute top-[40px] w-full z-70 min-h-10 max-h-52 h-auto overflow-y-auto`}
      >
        {options?.length > 0 ? (
          options.map((option, index) => (
            <p
              key={index}
              onClick={() => {
                onSelect(option.label, option.value);
                setToggleShow(false);
              }}
              className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white"
            >
              {option.label}
            </p>
          ))
        ) : (
          <p className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white">
            No data found
          </p>
        )}
      </div>
    </div>
  );
};

const Parallax = () => {
  const menuRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const hiddenFileInput = useRef(null);
  const [data, setData] = useState([]);
  const [showVal, setShowVal] = useState("NON PREMIUM");
  const [showVal2, setShowVal2] = useState("");
  const [showVal3, setShowVal3] = useState("");
  const [fileName, setFileName] = useState(["", "", ""]);
  const [fileDepth, setFileDepth] = useState(["", "", ""]);
  const [fileNamePreview, setFileNamePreview] = useState("");
  const [open, setOpen] = useState(false);
  const [updateId, setUpdateId] = useState([]);
  const [notification, setNotification] = useState(false);
  const [imageUpdate, setImageUpdate] = useState(false);
  const [collectionData, setCollectionData] = useState([]);
  const layers = ["Background", "Middleground", "Foreground"];

  const toggle = () => {
    setOpen(!open);
  };

  const sendNotification = (e) => {
    setNotification(e.target.checked);
  };

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const handleTagInputChange = (e) => {
    setTagInput(e.target.value);
  };

  const handleAddTag = () => {
    if (tagInput.trim() !== "") {
      if (tags === null || tags?.length === 0) {
        setTags([tagInput.trim()]);
      } else {
        setTags([...tags, tagInput.trim()]);
      }
      setTagInput("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    const updatedTags = tags.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
  };

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const handleSelect = (value, id) => {
    setShowVal(value);
    formik.setFieldValue("premium", id === "PREMIUM" ? true : false);
  };

  const handleSelect2 = (value, id) => {
    setShowVal2(value);
    formik.setFieldValue("categoryId", id);
  };

  const handleSelect3 = (value, id) => {
    setShowVal3(value);
    formik.setFieldValue("collectionId", id);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleClickLayer = (layerIndex) => {
    const inputRef = document.getElementById(`file-input-${layerIndex}`);
    inputRef.click();
  };

  const handleClickDepth = (layerIndex) => {
    const inputRef = document.getElementById(`file-depth-${layerIndex}`);
    inputRef.click();
  };

  const handleChange = (event, index) => {
    setImageUpdate(true);
    const fileUploaded = event.target.files[0];
    setFileName((prev) => {
      const updatedImages = [...prev];
      updatedImages[index] = fileUploaded;
      return updatedImages;
    });
    formik.setFieldValue("multiFile", (prev) => {
      const updatedImages = [...prev];
      updatedImages[index] = fileUploaded;
      return updatedImages;
    });
    setUpdateId((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });
  };

  const handleChangeDepth = (event, index) => {
    setImageUpdate(true);
    const fileUploaded = event.target.files[0];
    setFileDepth((prev) => {
      const updatedImages = [...prev];
      updatedImages[index] = fileUploaded;
      return updatedImages;
    });
    formik.setFieldValue("multiFile", (prev) => {
      const updatedImages = [...prev];
      updatedImages[index] = fileUploaded;
      return updatedImages;
    });
    setUpdateId((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });
  };

  const handleChangePreview = (event) => {
    const fileUploaded = event.target.files[0];
    formik.setFieldValue("previewImage", fileUploaded);
    setFileNamePreview(fileUploaded);
  };

  const ImageType = [
    { value: "PREMIUM", label: "PREMIUM" },
    { value: "NON PREMIUM", label: "NON PREMIUM" },
  ];

  const getAllData = async () => {
    try {
      const response = await CategoryService.GetAllCategory(0, 0);
      const data = response.data.apiresponse.data;
      setData(data.categories);
    } catch (error) {
      console.log("🚀  getAllData  error:", error);
    }
  };

  const getAllCollectionData = async () => {
    try {
      const response = await CollectionService.GetAllCollection(0, 0);
      const data = response.data.apiresponse.data;
      setCollectionData(data?.collections);
    } catch (error) {
      console.log("🚀  getAllCollectionData  error:", error);
    }
  };

  useEffect(() => {
    getAllData();
    getAllCollectionData();
  }, []);

  const CategoryOption = data.map((item) => {
    return {
      label: item.categoryName,
      value: item.id,
    };
  });

  const CollectionOption = collectionData.map((item) => {
    return {
      label: item.collectionName,
      value: item.id,
    };
  });

  useEffect(() => {
    if (location.state !== null) {
      const data = location.state;
      console.log(data);
      setTags(data.tags);
      setShowVal(data.isPremium === true ? "PREMIUM" : "NON PREMIUM");
      formik.setFieldValue("premium", data.isPremium);
      formik.setFieldValue("imageId", data.imageId);
      formik.setFieldValue("multimediaType", data.multimediaType);
      formik.setFieldValue("imageName", data.imageName);
      setFileNamePreview(
        data.url.split("/").pop().split("-").slice(1).join("-")
      );
      if (CategoryOption?.length > 0 && data.categoryId) {
        const abcd = CategoryOption.find(
          (item) => item.value === data.categoryId
        );
        if (abcd) {
          formik.setFieldValue("categoryId", abcd.value);
          setShowVal2(abcd.label);
        }
      }
      if (CollectionOption?.length > 0 && data.collectionId) {
        const abcd = CollectionOption.find(
          (item) => item.value === data.collectionId
        );
        if (abcd) {
          formik.setFieldValue("collectionId", abcd.value);
          setShowVal3(abcd.label);
        }
      }
      if (data.parallax4DList?.length > 0 || data?.parallax4DImage?.length) {
        if (data.parallax4DList?.length) {
          setFileName(
            data?.parallax4DList?.map((item) =>
              item.split("/").pop().split("-").slice(1).join("-")
            )
          );
        } else {
          data.parallax4DImage.forEach((item, index) => {
            formik.setFieldValue(`positions[${index}].speed`, item.speed);
          });
          setFileName(
            data?.parallax4DImage?.map((item) =>
              item?.layerImage?.split("/").pop().split("-").slice(1).join("-")
            )
          );
        }
      }

      if (data.depthList?.length > 0) {
        setFileDepth(
          data.depthList.map((item) =>
            item.split("/").pop().split("-").slice(1).join("-")
          )
        );
      }
    }
  }, [location, data]);

  const initialValue = {
    imageId: "",
    categoryId: "",
    imageName: "",
    premium: false,
    previewImage: "",
    image: "",
    tags: [],
    multiFile: [],
    collectionId: "",
    positions: [
      { left: "", right: "", top: "", bottom: "", speed: "" },
      { left: "", right: "", top: "", bottom: "", speed: "" },
      { left: "", right: "", top: "", bottom: "", speed: "" },
    ],
  };

  const schema = yup.object().shape({
    imageName: yup.string().required("Please enter image name"),
    previewImage:
      location.state === null && yup.mixed().required("Please select image"),
    premium: yup.string().required("Please select image Type"),
    // categoryId: yup.string().required("Please select category"),
    /* positions: yup.array().of(
      yup.object().shape({
        speed: yup.number().required("Speed is required"),
      })
    ), */
  });

  const submit = async (values, action) => {
    const {
      categoryId,
      imageName,
      premium,
      previewImage,
      imageId,
      positions,
      collectionId,
    } = values;
    try {
      const fileData = new FormData();
      const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
      fileData.append(
        "images.previewImage",
        previewImage !== "" ? previewImage : emptyFile
      );
      fileData.append("categoryId", categoryId || 0);
      fileData.append("imageName", imageName);
      fileData.append("premium", premium);
      fileData.append("collectionId", collectionId || 0);
      if (tags !== null) {
        fileData.append("tags", tags);
      }
      fileData.append(
        "images.layers.layer1",
        fileName[0]?.name ? fileName[0] : emptyFile
      );
      fileData.append(
        "images.layers.layer2",
        fileName[1]?.name ? fileName[1] : emptyFile
      );
      fileData.append(
        "images.layers.layer3",
        fileName[2]?.name ? fileName[2] : emptyFile
      );
      /* fileData.append(
        "images.depth1",
        fileDepth[0]?.name ? fileDepth[0] : emptyFile
      );
      fileData.append(
        "images.depth2",
        fileDepth[1]?.name ? fileDepth[1] : emptyFile
      );
      fileData.append(
        "images.depth3",
        fileDepth[2]?.name ? fileDepth[2] : emptyFile
      ); */
      positions.forEach((position, index) => {
        fileData.append(`images.layer${index + 1}.left`, position.left || 0);
        fileData.append(`images.layer${index + 1}.right`, position.right || 0);
        fileData.append(`images.layer${index + 1}.top`, position.top || 0);
        fileData.append(
          `images.layer${index + 1}.bottom`,
          position.bottom || 0
        );
        fileData.append(`images.layers.speed${index + 1}`, position.speed || 0);
      });
      if (imageId) {
        fileData.append("id", imageId);
      }
      fileData.append("sendNotification", notification);

      setLoader();
      await Parallax4DImageService.newCreate4DParallaxImage(fileData);
      // await Parallax4DImageService.create4DParallaxImage(fileData);
      // if (notification) {
      //   await NotificationService.sendNotification(notification);
      // }
      notifySuccess(
        imageId
          ? "4D parallax image update successfully"
          : "4D parallax image create successfully"
      );
      setImageUpdate(false);
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    } catch (error) {
      console.error("error", error);
      notifyError("Something went wrong");
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate(-1);
        action.resetForm();
      }, 1500);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const handleLeftChange = (e, index) => {
    console.log(e.target.value, index);
  };
  const handleRightChange = (e, index) => {
    console.log(e.target.value, index);
  };
  const handleTopChange = (e, index) => {
    console.log(e.target.value, index);
  };
  const handleBottomChange = (e, index) => {
    console.log(e.target.value, index);
  };
  const handleSpeedChange = (e, index) => {
    console.log(e.target.value, index);
  };

  return (
    <>
      <div
        className="max-w-[900px] min-w-[300px] w-auto px-5 pb-10"
        ref={menuRef}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="pt-10">
            <h1 className="text-base font-semibold leading-7 text-white pb-5">
              4D Parallax
            </h1>
            <div className="pb-2">
              <button onClick={toggle} type="button" className="btn save w-40">
                Add Tags
              </button>

              {open && (
                <div className="fixed inset-0 bg-[black]/60 z-[999] overflow-y-auto">
                  <div
                    className="flex items-center justify-center min-h-screen px-4"
                    // onClick={() => setOpen(false)}
                  >
                    <div className="bg-white overflow-hidden rounded-6 p-5 lg:p-7 max-w-[500px] w-full min-w-[350px]">
                      <h1 className="font-medium mb-5">Adding Title</h1>
                      <div className="flex flex-col gap-2 mb-7">
                        <label className="text-sm font-medium">Tag Title</label>
                        <input
                          className="bg-white w-full py-1.5 px-3 rounded-6 focus:outline-none border border-blue"
                          type="text"
                          placeholder="Enter Tag Name..."
                          value={tagInput}
                          onChange={handleTagInputChange}
                        />
                        <button
                          className="bg-blue w-full p-2 rounded-6 text-white font-medium"
                          onClick={handleAddTag}
                          type="button"
                        >
                          Add Tag
                        </button>
                      </div>
                      {tags &&
                        tags?.length > 0 &&
                        tags.map((tag, index) => (
                          <div key={index} className="border rounded-6 mb-1">
                            <div className="grid grid-cols-4 items-center border-b px-3 py-1.5">
                              <div className="col-span-3">
                                <span className="text-sm">{tag}</span>
                              </div>
                              <div className="col-span-1 flex justify-end border-l">
                                <button
                                  className="bg-red/80 text-white text-sm font-medium rounded-6 py-1.5 px-2.5"
                                  onClick={() => handleRemoveTag(tag)}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      <div className="flex justify-end gap-4 items-center mt-7">
                        <button
                          onClick={() => (
                            setOpen(false), setTags([]), setTagInput("")
                          )}
                          className="border border-red/80 text-red/80 font-medium rounded-6 py-1.5 px-2.5 w-full"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => setOpen(false)}
                          className="bg-blue text-white font-medium rounded-6 py-1.5 px-2.5 w-full"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="my-3">
                {!open &&
                  tags !== null &&
                  tags?.length > 0 &&
                  tags.map((tag, index) => (
                    <div className="flex items-center justify-between text-white py-1.5 px-3 rounded-full border-blue border mb-1">
                      {tag}
                      <MdDeleteOutline
                        onClick={() => handleRemoveTag(tag)}
                        className="text-red text-2xl cursor-pointer"
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* <h1 className="titles">4D Parallax</h1> */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Name</label>
            <input
              className="input"
              name="imageName"
              placeholder="image name"
              value={formik.values.imageName}
              onChange={formik.handleChange}
              type="text"
            />
            {formik.errors.imageName && formik.touched.imageName && (
              <div className="text-red text-sm">{formik.errors.imageName}</div>
            )}
          </div>

          {/* First Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Type</label>
            <Dropdown
              options={ImageType}
              onSelect={(value, id) => handleSelect(value, id)}
              selectedValue={showVal}
            />
            {formik.errors.premium && formik.touched.premium && (
              <div className="text-red text-sm">{formik.errors.premium}</div>
            )}
          </div>

          {/* Second Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Category</label>
            <Dropdown
              options={CategoryOption}
              onSelect={(value, id) => handleSelect2(value, id)}
              selectedValue={showVal2}
            />
            {formik.errors.categoryId && formik.touched.categoryId && (
              <div className="text-red text-sm">{formik.errors.categoryId}</div>
            )}
          </div>

          {/* Third Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Collection</label>
            <Dropdown
              options={CollectionOption}
              onSelect={(value, id) => handleSelect3(value, id)}
              selectedValue={showVal3}
            />
            {formik.errors.collectionId && formik.touched.collectionId && (
              <div className="text-red text-sm">
                {formik.errors.collectionId}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Preview Image</label>
            <div className="flex items-center gap-5">
              <input type="image" accept="image/*" id="upload" alt="" hidden />
              <label
                onClick={handleClick}
                className="border border-white rounded-6 flex items-center justify-center flex-col gap-5 p-4 cursor-pointer w-full lg:p-10 text-center"
              >
                <BsImage className="text-gray-600 text-5xl" />
                <span className="text-white text-sm  ">
                  {!fileNamePreview ? (
                    <>
                      <span className="text-center">
                        <strong>Upload a file</strong> or drag and drop <br />
                        PNG, JPG, GIF
                      </span>
                    </>
                  ) : (
                    fileNamePreview?.name || fileNamePreview
                  )}
                </span>
              </label>
              <input
                type="file"
                onChange={handleChangePreview}
                ref={hiddenFileInput}
                className="hidden"
                accept="image/*"
              />
            </div>
            {formik.errors.previewImage && formik.touched.previewImage && (
              <div className="text-red text-sm mb-4">
                {formik.errors.previewImage}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <div className="">
              <label className="label">List Of Layer Image</label>
              <div className="flex justify-between gap-10">
                <div className="mt-4 w-full">
                  {[...Array(3)].map((_, layerIndex) => (
                    <div className="w-full flex items-center gap-16 mb-4">
                      <div className="flex items-center gap-5">
                        <span className="text-white text-base font-medium whitespace-nowrap min-w-28">
                          {layers[layerIndex]}
                        </span>
                        <input type="image" id="upload" alt="" hidden />
                        <label
                          onClick={() => handleClickLayer(layerIndex)}
                          className="min-w-96 border-2 border-dashed border-blue rounded-6 flex justify-center items-center gap-2 px-4 py-2 cursor-pointer"
                        >
                          <BiImageAdd className="text-blue text-2xl" />
                          <span className="text-white text-sm  line-clamp-1 ">
                            {(fileName?.length > 0 &&
                              fileName[layerIndex] &&
                              fileName[layerIndex]?.name) ||
                            fileName[layerIndex]
                              ? fileName[layerIndex]?.name ||
                                fileName[layerIndex]
                              : "Upload or drop a file right here"}
                          </span>
                        </label>
                        <input
                          id={`file-input-${layerIndex}`}
                          type="file"
                          onChange={(e) => handleChange(e, layerIndex)}
                          className="hidden"
                        />
                      </div>
                      <div>
                        <div className="flex gap-5 justify-start items-center">
                          <label className="text-white text-base font-medium">
                            Speed
                          </label>
                          <div>
                            <input
                              type="number"
                              placeholder="Speed"
                              name={`positions[${layerIndex}].speed`}
                              className="input input-bordered custom-number-input"
                              value={
                                formik.values.positions[layerIndex]?.speed || ""
                              }
                              onChange={formik.handleChange}
                            />
                          </div>
                        </div>
                        {/* {fileName?.length > 0 && (
                          <div className="text-red text-sm">
                            {fileName[layerIndex] &&
                            !formik.values.positions[layerIndex].speed
                              ? "Speed is require"
                              : ""}
                          </div>
                        )} */}
                      </div>
                      <div className="pt-3 pb-6">
                        {/* <div className="flex gap-2 justify-between items-center">
                          <label className="text-white">Position</label>
                          <div className="flex gap-1">
                            <div>
                              <input
                                type="number"
                                placeholder="Left"
                                name={`positions[${layerIndex}].left`}
                                className="input input-bordered custom-number-input"
                                value={
                                  formik.values.positions[layerIndex]?.left ||
                                  ""
                                }
                                onChange={formik.handleChange}
                              />
                            </div>
                            <div>
                              <input
                                type="number"
                                placeholder="Right"
                                name={`positions[${layerIndex}].right`}
                                className="input input-bordered custom-number-input"
                                value={
                                  formik.values.positions[layerIndex]?.right ||
                                  ""
                                }
                                onChange={formik.handleChange}
                              />
                            </div>
                            <div>
                              <input
                                type="number"
                                placeholder="Top"
                                name={`positions[${layerIndex}].top`}
                                className="input input-bordered custom-number-input"
                                value={
                                  formik.values.positions[layerIndex]?.top || ""
                                }
                                onChange={formik.handleChange}
                              />
                            </div>
                            <div>
                              <input
                                type="number"
                                placeholder="Bottom"
                                name={`positions[${layerIndex}].bottom`}
                                className="input input-bordered custom-number-input"
                                value={
                                  formik.values.positions[layerIndex]?.bottom ||
                                  ""
                                }
                                onChange={formik.handleChange}
                              />
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  ))}
                </div>
                {/*  <div className="mt-4 ms-4 w-full">
                  {[...Array(3)].map((_, layerIndex) => (
                    <div className="flex items-center gap-5 mb-[70px]">
                      <span className="text-white text-base font-medium whitespace-nowrap">
                        Depth {layerIndex + 1}
                      </span>
                      <input type="image" id="upload" alt="" hidden />
                      <label
                        onClick={() => handleClickDepth(layerIndex)}
                        className="border-2 border-dashed border-blue rounded-6 flex items-center gap-2 p-2 cursor-pointer max-w-96 w-full"
                      >
                        <BiImageAdd className="text-blue text-2xl" />
                        <span className="text-white text-sm  line-clamp-1 ">
                          {(fileDepth.length > 0 &&
                            fileDepth[layerIndex] &&
                            fileDepth[layerIndex]?.name) ||
                          fileDepth[layerIndex]
                            ? fileDepth[layerIndex]?.name ||
                              fileDepth[layerIndex]
                            : "Upload or drop a file right here"}
                        </span>
                      </label>
                      <input
                        id={`file-depth-${layerIndex}`}
                        type="file"
                        onChange={(e) => handleChangeDepth(e, layerIndex)}
                        className="hidden"
                      />
                    </div>
                  ))}
                </div> */}
              </div>
            </div>
            <div className="flex gap-5 items-center pb-6"></div>
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="notificaiton"
              className="p-3"
              onChange={sendNotification}
            />
            <label
              htmlFor="notificaiton"
              className="text-white ps-4 cursor-pointer"
            >
              Send Notification
            </label>
          </div>
          <div className="flex justify-end gap-4 items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn cancel"
            >
              Cancel
            </button>
            <button type="submit" className="btn save">
              {loader ? <Loader /> : "Save"}
            </button>
          </div>
        </form>
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default Parallax;
